import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-input-checkbox__wrap" }
const _hoisted_2 = { class: "c-input-checkbox__icon__wrap" }
const _hoisted_3 = ["name", "value", "checked", "error", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconCheckbox = _resolveComponent("IconCheckbox")!
  const _component_IconBase = _resolveComponent("IconBase")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: _normalizeClass(["c-input-checkbox__label", [
        `-${_ctx.kind}`,
        {
          '-checked': _ctx.ischecked,
          '-disabled': _ctx.disabled
        }
      ]])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("input", {
          type: "checkbox",
          name: _ctx.name,
          value: _ctx.value,
          checked: _ctx.checked === _ctx.value,
          class: _normalizeClass(["c-input-checkbox", {
            'c-input-radio--error': _ctx.error
          }]),
          error: _ctx.error,
          disabled: _ctx.disabled,
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateValue && _ctx.updateValue(...args)))
        }, null, 42, _hoisted_3),
        _withDirectives(_createVNode(_component_IconBase, {
          "view-box": "0 0 18 18",
          width: "18",
          height: "18",
          class: "c-input-checkbox__icon"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconCheckbox)
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.value]
        ])
      ]),
      _createElementVNode("span", {
        class: _normalizeClass(["c-input-checkbox__text", { 'c-input-checkbox__text--checked': _ctx.checked === _ctx.value }])
      }, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ], 2)
    ], 2)
  ]))
}